import type { FC, ReactNode } from 'react'
import type { SourceRef } from '@/types'

import Link from 'next/link'
import { GraduationCap } from 'lucide-react'
import { cn } from '@/lib/utils'

interface SourceLineProps {
    source: SourceRef
    className?: string
}

const SourceLine: FC<SourceLineProps> = ({ source, className }): ReactNode => {
    if (!source.session_slug || !source.session_title) return null

    return (
        <Link
            href={`/sessions/${source.session_slug}`}
            className={cn('relative z-10 inline-flex max-w-full items-start gap-1.5 text-xs text-muted-foreground hover:text-foreground hover:underline', className)}
        >
            <GraduationCap className='mt-px size-4 shrink-0' aria-hidden='true' />

            <span className='min-w-0'>
                {source.course_title && source.course_id && (
                    <>
                        <span className='font-semibold' data-mdlfy-cms={`courses:${source.course_id}:title`}>
                            {source.course_title}
                        </span>

                        <span aria-hidden='true'> / </span>
                    </>
                )}

                <span data-mdlfy-cms={`sessions:${source.session_id}:title`}>
                    {source.session_title}
                </span>
            </span>
        </Link>
    )
}

export default SourceLine
